const CreativeAgencyNewFeedback = () => {
  return (
    <>
      <div className="sections feedback-section">
        <div className="sections__head">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <h2 className="text-center text-white mb-0">
                  Our Wall of Love 💛
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="row g-4">
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-1.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Sebastiaan Debrouwere
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @iamsebdeb
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        We use @attio on a daily basis for several internal
                        processes, and I cannot rave enough about them.
                        Incredible flexibility and features combined with super
                        intuitive UI
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-2.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Krishna
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @ntkris
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        Holy shit @attio is beautiful 😍 I've run my CRM on
                        Notion to date. Hubspot & Salesforce too clunky. Sleek
                        and simple, just what I need
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-3.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Eddy J. Prado 🔥
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @eddyjprado
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        For those who use Airtable as a CRM this
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="row g-4">
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-4.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Alon
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @alon
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        As an early stage startup I’m really loving using @attio
                        - great balance of flexibility
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-5.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Jono Bacon
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @jonobacon
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        Let's be honest, most CRMs suck. Overcomplicated,
                        expensive, and you have to bend to their will...not the
                        other way around. I am a huge fan of @attio - their
                        product
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-6.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Meltem Demirors
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @Melt_Dem
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        Let's be honest, most CRMs suck. Overcomplicated,
                        expensive
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="row g-4">
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-7.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Dimitry Gershenson
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @d_gershenson
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        We use our CRM @attio for sales, fundraising, and
                        recruiting. It's awesome
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-8.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Sri
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @therealsrii
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        I've been using @attio to track applicants, manage my
                        deal pipeline and manage the associated notes/tasks. The
                        use-cases are unlimited; it truly feels like the Notion
                        of CRM.
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card twitter-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between gap-4 mb-4">
                        <div className="d-flex gap-3 align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src="assets/img/tw-user-9.png"
                              alt="image"
                              className="img-fluid"
                            />
                          </div>
                          <div className="flex-grow-1">
                            <span className="d-block twitter-card__user">
                              Fabian
                            </span>
                            <span className="d-block twitter-card__user-sub">
                              @FabstheAustrian
                            </span>
                          </div>
                        </div>
                        <span className="d-inline-block flex-shrink-0 twitter-card__icon">
                          <i className="fab fa-twitter"></i>
                        </span>
                      </div>
                      <p className="twitter-card__msg">
                        For CRM or deal flow, @attio is in a className of its
                        own.
                      </p>
                      <span className="d-block twitter-card__time">
                        10:01 PM · Apr 7, 2022
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sections pb-0 pricing-section">
          <div className="sections__head">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12">
                  <h2 className="text-center text-white mb-0">
                    Unlock Micro Interactions Pro ✨
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center g-4 g-xl-0">
              <div className="col-md-6 col-xl-5">
                <div className="card price-card-36 price-card-36--first">
                  <div className="card-body">
                    <h3 className="price-card-36__title mb-0">Annual</h3>
                    <ul className="list-unstyled mb-0">
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>Unlock</strong> all Featured Interactions
                      </li>
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>48+</strong> Button hover interactions
                      </li>
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>05</strong> Business paling Included
                      </li>
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>Fully</strong> customizable
                      </li>
                    </ul>
                    <div className="price-card-36__price">
                      <h5 className="price-card-36__price-title">
                        Billed Annually
                      </h5>
                      <h2 className="price-card-36__price-is">
                        $40{" "}
                        <small className="price-card-36__price-sm fw-normal text-decoration-line-through">
                          $117
                        </small>
                      </h2>
                    </div>
                    <a href="#" className="btn btn-36 fw-medium text-center">
                      Get Annual Plan
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-5">
                <div className="card price-card-36 price-card-36--popular">
                  <div className="card-body">
                    <h3 className="price-card-36__title mb-0">
                      Lifetime Access
                    </h3>
                    <ul className="list-unstyled mb-0">
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>Unlock</strong> all Featured Interactions
                      </li>
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>48+</strong> Button hover interactions
                      </li>
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>05</strong> Business paling Included
                      </li>
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>Fully</strong> customizable
                      </li>
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>Advanced</strong> anti-spam
                      </li>
                      <li className="py-2">
                        <i className="fas fa-check-circle me-1 text-success"></i>
                        <strong>Lifetime</strong> Access & Updates
                      </li>
                    </ul>
                    <div className="price-card-36__price">
                      <h5 className="price-card-36__price-title">
                        Lifetime Offer{" "}
                        <span className="price-card-36__price-title-highlight">
                          (only 12 spots left)
                        </span>
                      </h5>
                      <h2 className="price-card-36__price-is">
                        $75{" "}
                        <small className="price-card-36__price-sm fw-normal text-decoration-line-through">
                          $117
                        </small>
                      </h2>
                    </div>
                    <a href="#" className="btn btn-36 fw-medium text-center">
                      Get Lifetime Access
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyNewFeedback;
